import {URL_PRIVACY_POLICY, URL_TERMS_AND_CONDITIONS} from "@/lib/links.ts";

export const PrivacyFooter = () => (
  <div className="mt-3 text-center pulseTextBodySmall pulse-color-gray-700">
    By submitting this form, you are accepting our{" "}
    <a target="_blank" rel="noreferrer" href={URL_TERMS_AND_CONDITIONS}>
      Terms & Conditions
    </a>{" "}
    and{" "}
    <a target="_blank" rel="noreferrer" href={URL_PRIVACY_POLICY}>
      Privacy Policy
    </a>
    .
  </div>
);
